"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Name = _interopRequireDefault(require("../Name/Name"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _communication = require("../../../../icons-react/communication");
var _excluded = ["id", "fullName", "phone", "email", "emailable", "ticketable", "onCallClick", "onEmailClick", "onCreateTicket"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ClientSearchCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var id = _ref.id,
    fullName = _ref.fullName,
    phone = _ref.phone,
    email = _ref.email,
    emailable = _ref.emailable,
    ticketable = _ref.ticketable,
    onCallClick = _ref.onCallClick,
    onEmailClick = _ref.onEmailClick,
    onCreateTicket = _ref.onCreateTicket,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isHovering = _useState2[0],
    setHovering = _useState2[1];
  var handleMouseHover = function handleMouseHover() {
    return setHovering(!isHovering);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledClientSearchCard, props, id && /*#__PURE__*/_react["default"].createElement(StyledIdentifier, {
    title: id
  }, id), /*#__PURE__*/_react["default"].createElement(StyledName, {
    name: fullName
  }), phone && /*#__PURE__*/_react["default"].createElement(StyledPhoneButton, {
    onClick: onCallClick,
    onMouseEnter: handleMouseHover,
    onMouseLeave: handleMouseHover
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, phone), isHovering && /*#__PURE__*/_react["default"].createElement(StyledPhoneIcon, null)), email && /*#__PURE__*/_react["default"].createElement(StyledEmailButton, {
    onClick: onEmailClick,
    disabled: !emailable,
    emailable: emailable
  }, /*#__PURE__*/_react["default"].createElement(StyledEmailLabel, null, email)));
});
ClientSearchCard.displayName = 'ClientSearchCard';
ClientSearchCard.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  fullName: _propTypes["default"].string.isRequired,
  phone: _propTypes["default"].string,
  email: _propTypes["default"].string,
  emailable: _propTypes["default"].bool,
  ticketable: _propTypes["default"].bool,
  onCallClick: _propTypes["default"].func,
  onEmailClick: _propTypes["default"].func,
  onCreateTicket: _propTypes["default"].func
};
ClientSearchCard.defaultProps = {
  className: '',
  phone: '',
  email: '',
  emailable: true,
  ticketable: true,
  onCallClick: Function.prototype,
  onEmailClick: Function.prototype,
  onCreateTicket: Function.prototype
};
var StyledClientSearchCard = _styledComponents["default"].div.withConfig({
  displayName: "ClientSearchCard__StyledClientSearchCard",
  componentId: "sc-180gk6d-0"
})(["background-color:#fff;height:44px;width:100%;padding:14px 0px 14px 0px;display:flex;"]);
var StyledIdentifier = _styledComponents["default"].div.withConfig({
  displayName: "ClientSearchCard__StyledIdentifier",
  componentId: "sc-180gk6d-1"
})(["padding-right:9px;font-size:14px;line-height:1.29;letter-spacing:normal;color:#919499;::before{content:'#';}"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "ClientSearchCard__StyledName",
  componentId: "sc-180gk6d-2"
})(["font-size:14px;white-space:nowrap;min-width:150px;display:inline-block;vertical-align:middle;text-overflow:ellipsis;flex-grow:1;"]);
var StyledButtonReset = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientSearchCard__StyledButtonReset",
  componentId: "sc-180gk6d-3"
})(["padding:0;border:none;background:none;"]);
var StyledPhoneButton = (0, _styledComponents["default"])(StyledButtonReset).withConfig({
  displayName: "ClientSearchCard__StyledPhoneButton",
  componentId: "sc-180gk6d-4"
})(["margin-left:9px;font-size:14px;text-align:center;font-family:inherit;text-decoration:none;width:auto;height:18px;color:#919499;&:hover{color:#007aff;}&:disabled{pointer-events:none;svg path{stroke:#c2c5cc;}}"]);
var StyledEmailButton = (0, _styledComponents["default"])(StyledButtonReset).withConfig({
  displayName: "ClientSearchCard__StyledEmailButton",
  componentId: "sc-180gk6d-5"
})(["height:18px;font-size:14px;margin-left:11px;text-align:center;font-family:inherit;text-decoration:none;width:auto;color:#919499;", ""], function (props) {
  return props.emailable && "\n    &:hover {\n      color: #007aff;\n    }\n  ";
});
var StyledEmailLabel = _styledComponents["default"].span.withConfig({
  displayName: "ClientSearchCard__StyledEmailLabel",
  componentId: "sc-180gk6d-6"
})(["height:17px;overflow:hidden;min-width:119px;white-space:nowrap;display:inline-block;vertical-align:middle;text-overflow:ellipsis;"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "ClientSearchCard__StyledLabel",
  componentId: "sc-180gk6d-7"
})(["height:17px;overflow:hidden;max-width:119px;white-space:nowrap;display:inline-block;vertical-align:middle;text-overflow:ellipsis;"]);
var StyledPhoneIcon = (0, _styledComponents["default"])(_communication.Call).withConfig({
  displayName: "ClientSearchCard__StyledPhoneIcon",
  componentId: "sc-180gk6d-8"
})(["width:17px;height:17px;margin-left:4px;display:inline-block;vertical-align:middle;"]);
var _default = exports["default"] = ClientSearchCard;